import React from 'react';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import Header from '../../Header';
import AnimatedBanner from '../../AnimatedBanner';
import Breadcrumbs from '../../Breadcrumbs';
import Heading from '../Heading';
import Search from '../Search';
import SearchWrapper from '../../Search/context/Search';

const StyledRoot = styled(AnimatedBanner)`
  &.GuidesTop__AnimatedBanner {
    background-position: top;
    background-size: cover;
    background-attachment: initial;
    background-color: #001b28;
  }

  &.GuidesTop__AnimatedBanner .Header--headerTransparent.Header__wrapper {
    height: 106px;
  }

  &.GuidesTop__AnimatedBanner
    .Header--headerTransparent.Header__wrapper--notificationAlertHidden
    .Header__root {
    padding-top: 0;
  }

  &.GuidesTop__AnimatedBanner
    .Header--headerTransparent.Header__wrapper.Header__wrapper--notificationAlertHidden {
    height: 60px !important;
  }

  &.GuidesTop__AnimatedBanner .Landing__Search__root {
    margin-bottom: 125px;
  }

  @media (max-width: 767px) {
    &.GuidesTop__AnimatedBanner .Header--headerTransparent.Header__wrapper {
      height: 62px;
    }
    &.GuidesTop__AnimatedBanner
      .Header--headerTransparent.Header__wrapper.Header__wrapper--notificationAlertShow {
      height: 106px;
    }

    &.GuidesTop__AnimatedBanner .Landing__Search__root {
      margin-bottom: 20px;
    }
  }
`;

const StyledBannerContent = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 645px;
  padding-left: 20px;
  padding-right: 20px;
  flex: 1;
  min-height: 100px;
  padding-bottom: 0;

  .Breadcrumbs__root {
    align-self: start;
    margin-left: 10px;
    margin-top: 15px;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }

  .Breadcrumbs__item,
  .Breadcrumbs__divider {
    color: #ffffff;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .Breadcrumbs__root a:hover {
    color: #ffffff;
  }

  @media (max-width: 1024px) {
    min-height: 0;
    padding: 0 16px;
    .Breadcrumbs__root {
      margin-left: 0;
    }
  }
  @media (max-width: 767px) {
    .Breadcrumbs__root {
      margin-bottom: 40px;
    }
  }
`;

const StyledSubHeading = styled(Container)`
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3em;
  color: #ffffff;
  margin-top: 8px;

  @media (max-width: 767px) {
    margin-right: auto;
  }
`;

const GuidesTop = ({
  heading,
  subHeading,
  defaultCategoryValue,
  bannerImage,
  headerTransparent,
  searchShow = true,
  breadcrumbs,
  children,
}) => {
  return (
    <StyledRoot bannerImage={bannerImage} className="GuidesTop__AnimatedBanner">
      <SearchWrapper>
        <Header
          defaultCategoryValue={defaultCategoryValue}
          slideIn
          headerTransparent={headerTransparent}
        />
        <StyledBannerContent className="Landing__GuidesTop__bannerContent">
          {breadcrumbs && <Breadcrumbs data={breadcrumbs} />}
          <Heading>{heading}</Heading>
          {subHeading && (
            <StyledSubHeading className="Landing__GuidesTop__subHeading">
              {subHeading}
            </StyledSubHeading>
          )}
          {searchShow && <Search defaultCategoryValue={defaultCategoryValue} />}
          {children}
        </StyledBannerContent>
      </SearchWrapper>
    </StyledRoot>
  );
};

export default GuidesTop;
